import React from "react";
import {
  FormControl,
  Button,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import roundClearAll from "@iconify/icons-ic/round-clear-all";
import { Icon } from "@iconify/react";

export default function AccountFilter({
  setIsAllDates,
  isAllDates,
  handleClearFilter,
  filterData,
  searchSubmitFilter,
  handleChangeOthers,
  setFilterData,
  deposit,
}) {
  return (
    <div className="container-fluid new-memories transaction-filter">
      <FormControl fullWidth className="mt-4">
        <InputLabel id="demo-simple-select-label">
          Select Account Type
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={filterData.account_type}
          name="account_type"
          label="Select Account Type"
          onChange={(e) => handleChangeOthers("account_type", e.target.value)}
        >
          <MenuItem value={"facebook"}>Facebook</MenuItem>
          <MenuItem value={"tiktok"}>Tiktok</MenuItem>
        </Select>
      </FormControl>
      {deposit ? (
        <FormControl fullWidth className="mt-3">
          <InputLabel id="status_value-label">Select Status</InputLabel>
          <Select
            labelId="status-label"
            id="status_value"
            value={filterData.status_value || ""}
            name="status_value"
            label="Select Status"
            onChange={(e) => handleChangeOthers("status_value", e.target.value)}
          >
            <MenuItem value="succeeded">Succeeded</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
            <MenuItem value="requires_action">Requires Action</MenuItem>
          </Select>
        </FormControl>
      ) : (
        <FormControl fullWidth className="mt-3">
          <InputLabel id="status_value-label">Select Status</InputLabel>
          <Select
            labelId="status-label"
            id="status_value"
            value={filterData.status_value || ""}
            name="status_value"
            label="Select Status"
            onChange={(e) => handleChangeOthers("status_value", e.target.value)}
          >
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="need-changes">Need Changes</MenuItem>
            <MenuItem value="review">Review</MenuItem>
            <MenuItem value="disabled">Disabled</MenuItem>
          </Select>
        </FormControl>
      )}
      <Box sx={{ py: 2 }}>
        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="outlined"
          onClick={searchSubmitFilter}
          startIcon={
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 5 }}
            >
              <path
                d="M13.1165 0.25H0.883548C0.321452 0.25 0.0378205 0.932013 0.436097 1.33029L5.3125 6.20743V11.6406C5.3125 11.8471 5.41325 12.0406 5.58242 12.1591L7.69179 13.6351C8.10794 13.9264 8.6875 13.6312 8.6875 13.1167V6.20743L13.564 1.33029C13.9615 0.932804 13.6798 0.25 13.1165 0.25Z"
                fill="#fff"
              />
            </svg>
          }
        >
          Filter
        </Button>
      </Box>
      <Button
        className="mb-3"
        fullWidth
        size="large"
        type="submit"
        color="inherit"
        variant="outlined"
        onClick={handleClearFilter}
        startIcon={<Icon icon={roundClearAll} />}
      >
        Clear All
      </Button>
    </div>
  );
}
